var _style, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRipeNccLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "707.9px",
    height: "177.8px",
    viewBox: "0 0 707.9 177.8",
    style: {
      enableBackground: "new 0 0 707.9 177.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#25316A;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#5B5C87;}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.5,108.8l-15.9-28.3h-9.1v28.3h-20.1V28.6h35.1c8,0,14.2,1.7,19.2,5.4c6.2,4.5,9.4,11.9,9.4,19.9 c0,9.8-4.7,19.3-15.2,23.6l18.4,31.3H242.5z M229.9,44.4h-12.5v21.2h12.5c7.2,0,11.7-4.2,11.7-10.7 C241.6,47.5,236.6,44.4,229.9,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.5,108.8V28.6h20.1v80.2H273.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344,81.1h-16.7v27.8h-20V28.6h36.2c17.8,0,28.1,10.9,28.1,25.7C371.6,67.6,363.5,81.1,344,81.1z  M340.3,44.4h-12.9v21.2h12.9c6.9,0,11.7-3.6,11.7-10.8C352,47.9,347.5,44.4,340.3,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.7,108.8V28.6h59v16.3h-39v15.3h32.8v16.2h-32.8v16h39.2v16.4H381.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M531.7,108.8l-31.4-47.1h-0.2v47.1h-18.6V28.6H501L531.5,74h0.2V28.6h18.7v80.2H531.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M596.1,110.2c-17.7,0-34.2-8.9-34.2-28.9V57c0-19.7,16-29.6,33.6-29.6c15.6,0,32.6,7.9,32.6,26.4v5.1h-18.9 v-3.2c0-8.3-7.1-11.9-13.3-11.9c-7.1,0-13.9,3.7-13.9,12.8v24.3c0,8.2,6,12.9,14.2,12.9c6.2,0,13-3.5,13-11.9v-3.3h18.9v5.4 C628.1,102.3,611.6,110.2,596.1,110.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M671.5,110.2c-17.7,0-34.2-8.9-34.2-28.9V57c0-19.7,16-29.6,33.6-29.6c15.6,0,32.6,7.9,32.6,26.4v5.1h-18.9 v-3.2c0-8.3-7.1-11.9-13.3-11.9c-7.1,0-13.9,3.7-13.9,12.8v24.3c0,8.2,6,12.9,14.2,12.9c6.2,0,13-3.5,13-11.9v-3h18.9v5.1 C703.6,102.3,687,110.2,671.5,110.2z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.2498,
    y1: 9.25,
    x2: 149.6498,
    y2: 132.65,
    gradientTransform: "matrix(1 0 0 -1 0 180)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25316A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06051821,
    style: {
      stopColor: "#293269"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    style: {
      stopColor: "#343468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    style: {
      stopColor: "#453764"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2446,
    style: {
      stopColor: "#5B3C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3064,
    style: {
      stopColor: "#764459"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3684,
    style: {
      stopColor: "#964D4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    style: {
      stopColor: "#BF5A3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4872,
    style: {
      stopColor: "#F36C21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C9C9C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.2,75.6L131.2,75.6V28.9l-43.3-25l-43.3,25v46.6v0.1L4.3,98.8v50l43.3,25l40.3-23.3l40.3,23.3l43.3-25v-50 L131.2,75.6z M87.9,97.1L53.5,77.2l34.4-19.9l34.4,19.9L87.9,97.1z M50.5,82.3l34.4,19.9V142l-34.4-19.9L50.5,82.3z M90.8,102.2 l34.4-19.9v39.7l-34.4,19.8V102.2z M50.5,32.3l37.4-21.6l37.4,21.6v39.7L87.9,50.5L50.5,72.1L50.5,32.3z M10.2,145.4v-43.2 l34.4-19.9v43.1L82,147l-34.5,19.9L10.2,145.4z M165.6,145.4L128.2,167l-34.5-19.9l37.4-21.6V82.3l34.4,19.9L165.6,145.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.7,141v7.9h-2.2v-19.1h5.2c2.3,0,4.1,0.4,5.2,1.3s1.7,2.2,1.7,4.1c0,2.5-1.3,4.2-3.8,5.1l5.2,8.6h-2.7 l-4.6-7.9H200.7z M200.7,139.1h3c1.6,0,2.7-0.3,3.5-0.9s1.1-1.6,1.1-2.8c0-1.3-0.4-2.2-1.1-2.7s-1.9-0.8-3.6-0.8h-2.9V139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.1,148.9v-19.1h2.2v19.1H215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.8,135.4c0,1.9-0.7,3.4-2,4.5c-1.3,1-3.2,1.6-5.7,1.6h-2.2v7.5h-2.2v-19.1h5 C232.4,129.8,234.8,131.6,234.8,135.4z M224.9,139.5h2c2,0,3.4-0.3,4.3-1c0.9-0.6,1.3-1.7,1.3-3.1c0-1.3-0.4-2.2-1.2-2.8 c-0.8-0.6-2.1-0.9-3.9-0.9h-2.5L224.9,139.5L224.9,139.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.5,148.9h-10.7v-19.1h10.7v2h-8.4v6.2h7.9v2h-7.9v7h8.4V148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.8,148.9h-2.5l-10.4-16h-0.1c0.1,1.9,0.2,3.6,0.2,5.2v10.8h-2.1v-19.1h2.5l10.4,16h0.1 c0-0.2-0.1-1-0.1-2.3c-0.1-1.3-0.1-2.2-0.1-2.7v-11h2.1V148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.8,148.9h-10.7v-19.1h10.7v2h-8.5v6.2h7.9v2h-7.9v7h8.4v1.9H291.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302,148.9h-2.2v-17.1h-6.1v-2H308v2h-6.1v17.1H302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M327.7,148.9h-2.2l-3.9-12.8c-0.2-0.6-0.4-1.3-0.6-2.1s-0.3-1.4-0.4-1.6c-0.2,1.2-0.5,2.4-0.9,3.8l-3.7,12.7 h-2.2l-5.1-19.1h2.4l3,11.8c0.4,1.7,0.7,3.2,0.9,4.5c0.2-1.6,0.6-3.2,1-4.7l3.4-11.6h2.4l3.6,11.7c0.4,1.4,0.8,2.9,1.1,4.6 c0.2-1.2,0.5-2.7,0.9-4.5l3-11.8h2.4L327.7,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M352.4,139.2c0,3.1-0.8,5.5-2.3,7.2c-1.5,1.8-3.7,2.6-6.5,2.6s-5-0.9-6.5-2.6s-2.3-4.2-2.3-7.3 c0-3.1,0.8-5.5,2.3-7.2s3.7-2.6,6.5-2.6c2.7,0,4.9,0.9,6.4,2.6C351.7,133.9,352.4,136.2,352.4,139.2z M337.2,139.2 c0,2.6,0.6,4.6,1.7,5.9s2.7,2,4.8,2c2.1,0,3.7-0.7,4.8-2c1.1-1.3,1.6-3.3,1.6-5.9s-0.5-4.5-1.6-5.8s-2.7-2-4.8-2 c-2.1,0-3.7,0.7-4.8,2C337.8,134.8,337.2,136.8,337.2,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M359,141v7.9h-2.2v-19.1h5.2c2.3,0,4.1,0.4,5.2,1.3s1.7,2.2,1.7,4.1c0,2.5-1.3,4.2-3.8,5.1l5.2,8.6h-2.6 l-4.6-7.9H359z M359,139.1h3c1.6,0,2.7-0.3,3.5-0.9s1.1-1.6,1.1-2.8c0-1.3-0.4-2.2-1.1-2.7c-0.7-0.6-1.9-0.8-3.6-0.8H359V139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M387.2,148.9h-2.6l-7-9.3l-2,1.8v7.5h-2.2v-19.1h2.2v9.5l8.7-9.5h2.6l-7.7,8.3L387.2,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M405.1,131.5c-2.1,0-3.8,0.7-5,2.1s-1.8,3.3-1.8,5.7c0,2.5,0.6,4.4,1.8,5.8c1.2,1.4,2.8,2,5,2 c1.3,0,2.9-0.2,4.6-0.7v1.9c-1.3,0.5-3,0.7-4.9,0.7c-2.8,0-5-0.9-6.5-2.6s-2.3-4.1-2.3-7.3c0-2,0.4-3.7,1.1-5.2s1.8-2.6,3.2-3.4 s3-1.2,4.9-1.2c2,0,3.8,0.4,5.3,1.1l-0.9,1.9C408,131.9,406.6,131.5,405.1,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M430.5,139.2c0,3.1-0.8,5.5-2.3,7.2c-1.5,1.8-3.7,2.6-6.5,2.6s-5-0.9-6.5-2.6s-2.3-4.2-2.3-7.3 c0-3.1,0.8-5.5,2.3-7.2s3.7-2.6,6.5-2.6c2.7,0,4.9,0.9,6.4,2.6C429.7,133.9,430.5,136.2,430.5,139.2z M415.3,139.2 c0,2.6,0.6,4.6,1.7,5.9s2.7,2,4.8,2c2.1,0,3.7-0.7,4.8-2c1.1-1.3,1.6-3.3,1.6-5.9s-0.5-4.5-1.6-5.8s-2.7-2-4.8-2 c-2.1,0-3.7,0.7-4.8,2C415.8,134.8,415.3,136.8,415.3,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M451.4,139.2c0,3.1-0.8,5.5-2.3,7.2c-1.5,1.8-3.7,2.6-6.5,2.6s-5-0.9-6.5-2.6s-2.3-4.2-2.3-7.3 c0-3.1,0.8-5.5,2.3-7.2s3.7-2.6,6.5-2.6c2.7,0,4.9,0.9,6.4,2.6C450.7,133.9,451.4,136.2,451.4,139.2z M436.2,139.2 c0,2.6,0.6,4.6,1.7,5.9s2.7,2,4.8,2c2.1,0,3.7-0.7,4.8-2c1.1-1.3,1.6-3.3,1.6-5.9s-0.5-4.5-1.6-5.8s-2.7-2-4.8-2 c-2.1,0-3.7,0.7-4.8,2C436.8,134.8,436.2,136.8,436.2,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M458,141v7.9h-2.2v-19.1h5.2c2.3,0,4.1,0.4,5.2,1.3s1.7,2.2,1.7,4.1c0,2.5-1.3,4.2-3.8,5.1l5.2,8.6h-2.6 l-4.6-7.9H458z M458,139.1h3c1.6,0,2.7-0.3,3.5-0.9s1.1-1.6,1.1-2.8c0-1.3-0.4-2.2-1.1-2.7s-1.9-0.8-3.6-0.8H458V139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M487.7,139.1c0,3.2-0.9,5.6-2.6,7.2c-1.7,1.7-4.2,2.5-7.4,2.5h-5.3v-19.1h5.9c3,0,5.3,0.8,6.9,2.5 C486.8,133.9,487.7,136.1,487.7,139.1z M485.3,139.2c0-2.5-0.6-4.4-1.9-5.6c-1.2-1.3-3.1-1.9-5.6-1.9h-3.2V147h2.7 c2.6,0,4.6-0.7,6-2C484.6,143.6,485.3,141.8,485.3,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M492,148.9v-19.1h2.2v19.1H492z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M514.5,148.9H512l-10.4-16h-0.1c0.1,1.9,0.2,3.6,0.2,5.2v10.8h-2.1v-19.1h2.5l10.4,16h0.1 c0-0.2-0.1-1-0.1-2.3c-0.1-1.3-0.1-2.2-0.1-2.7v-11h2.1L514.5,148.9L514.5,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M531.8,148.9l-2.4-6.1h-7.7l-2.4,6.1h-2.2l7.6-19.2h1.9l7.5,19.2H531.8z M528.7,140.8l-2.2-5.9 c-0.3-0.8-0.6-1.7-0.9-2.8c-0.2,0.8-0.5,1.8-0.8,2.8l-2.2,5.9H528.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M542.7,148.9h-2.2v-17.1h-6.1v-2h14.3v2h-6.1L542.7,148.9L542.7,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M551.7,148.9v-19.1h2.2v19.1H551.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M575.8,139.2c0,3.1-0.8,5.5-2.3,7.2c-1.5,1.8-3.7,2.6-6.5,2.6s-5-0.9-6.5-2.6s-2.3-4.2-2.3-7.3 c0-3.1,0.8-5.5,2.3-7.2s3.7-2.6,6.5-2.6c2.7,0,4.9,0.9,6.4,2.6C575.1,133.9,575.8,136.2,575.8,139.2z M560.6,139.2 c0,2.6,0.6,4.6,1.7,5.9c1.1,1.3,2.7,2,4.8,2s3.7-0.7,4.8-2s1.6-3.3,1.6-5.9s-0.5-4.5-1.6-5.8s-2.7-2-4.8-2s-3.7,0.7-4.8,2 S560.6,136.8,560.6,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M595.1,148.9h-2.5l-10.4-16h-0.1c0.1,1.9,0.2,3.6,0.2,5.2v10.8h-2.1v-19.1h2.5l10.4,16h0.1 c0-0.2-0.1-1-0.1-2.3c-0.1-1.3-0.1-2.2-0.1-2.7v-11h2.1L595.1,148.9L595.1,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M615.7,131.5c-2.1,0-3.8,0.7-5,2.1s-1.8,3.3-1.8,5.7c0,2.5,0.6,4.4,1.8,5.8s2.8,2,5,2c1.3,0,2.9-0.2,4.6-0.7 v1.9c-1.3,0.5-3,0.7-4.9,0.7c-2.8,0-5-0.9-6.5-2.6s-2.3-4.1-2.3-7.3c0-2,0.4-3.7,1.1-5.2c0.7-1.5,1.8-2.6,3.2-3.4s3-1.2,4.9-1.2 c2,0,3.8,0.4,5.3,1.1l-0.9,1.9C618.6,131.9,617.1,131.5,615.7,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M635.1,148.9h-10.7v-19.1h10.7v2h-8.4v6.2h7.9v2h-7.9v7h8.4V148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M654.4,148.9h-2.5l-10.4-16h-0.2c0.1,1.9,0.2,3.6,0.2,5.2v10.8h-2.1v-19.1h2.5l10.4,16h0.1 c0-0.2-0.1-1-0.1-2.3c-0.1-1.3-0.1-2.2-0.1-2.7v-11h2.1L654.4,148.9L654.4,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M665.6,148.9h-2.3v-17.1h-6v-2h14.3v2h-6.1L665.6,148.9L665.6,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M676.8,141v7.9h-2.2v-19.1h5.2c2.3,0,4.1,0.4,5.2,1.3s1.7,2.2,1.7,4.1c0,2.5-1.3,4.2-3.8,5.1l5.2,8.6h-2.6 l-4.6-7.9H676.8z M676.8,139.1h3c1.6,0,2.7-0.3,3.5-0.9s1.1-1.6,1.1-2.8c0-1.3-0.4-2.2-1.1-2.7s-1.9-0.8-3.6-0.8h-2.9V139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M701.9,148.9h-10.7v-19.1h10.7v2h-8.4v6.2h7.9v2h-7.9v7h8.4V148.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipeNccLogo);
export default __webpack_public_path__ + "static/media/RipeNccLogo.b355ec92ac622b8b366a015c9a685b10.svg";
export { ForwardRef as ReactComponent };